import { createRouter, createWebHistory } from 'vue-router'
import { constantRoutes } from './routes'

// 创建路由实例
const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes
})

// 路由守卫：权限检查
router.beforeEach((to, _, next) => {
  const token = localStorage.getItem('access_token')
  
  // 检查是否需要认证
  if (to.meta?.requiresAuth && !token) {
    return next('/login')
  }
  
  // 已登录状态下访问登录页，重定向到首页
  if (to.path === '/login' && token) {
    return next('/')
  }
  
  next()
})

// 导出路由实例
export default router

// 导出工具函数供其他组件使用
export * from './routes'
